export default "__VITE_ASSET__03030ce5__"